export enum ActionConstants {
	SET_TRADE_MODE = 'SET_TRADE_MODE',
	SET_TRADES = 'SET_TRADES',
	ADD_TRADE = 'ADD_TRADE',
}
